import { route } from 'preact-router';
import { CloseWebviewEvent } from '../sdk/close.webview.event';

export default class NavigationUtils {
  static Routes = {
    LUCKY_HOME: '/lucky-home',
    KYC: '/kyc',
    ONBOARDING: '/onboarding',
    ONBOARDING_STATUS: '/onboarding-status',
    ONBOARDING_ERROR: '/onboarding-error',
    ONBOARDING_SUCCESS: '/onboarding-success',
    CARD_ACTIVATION: '/card-activation',
    CARD_ACTIVATION_STATUS: '/card-activation-status',
    CARD_ACTIVATION_INFO: '/card-activation-info',
    CARD_SETTINGS: '/card-settings',
    COMPLETE: '/complete',
    CREDIT_ONBOARDING: '/credit-onboarding',
    SET_PIN: '/set-pin',
    SET_PIN_STATUS: '/set-pin-status',
    RESET_PIN: '/reset-pin',
    RESET_PIN_STATUS: '/reset-pin-status',
    REPORT_CARD_STATUS: '/report-card-status',
    TRY_AGAIN: '/try-again',
    PICKUP: '/pickup',
    PICKUP_LISTING: '/pickup/listing',
    PICKUP_DETAIL: '/pickup/detail',
    WALLET: '/wallet',
    TOPUP: '/topup',
    TOPUP_CARD_LISTING: '/topup-card-listing',
    TOPUP_DETAIL: '/topup-detail',
    ADD_CARD: '/add-card',
    NO_CARDS: '/no-cards',
    LANDING_PAGE: '/landing-page',
    NOTIFICATION_CENTER: '/notification-center',
    OUTLINE_ONBOARDING: '/outline-onboarding',
    P2P_CONTACT_LIST: '/p2p-contact-list/:cardUid',
    P2P_CONTACT_CARD_LIST: '/p2p-contact-card-list/:cardUid/:contactUserId',
    P2P_MANUAL_PHONE_NUMBER: '/p2p-manual-phone-number/:cardUidFrom',
    ENTER_AMOUNT: '/enter-amount',
    SUMMARY: '/summary',
    P2P_RESULT: '/p2p-result/:type',
    EDUCATIONAL_ONBOARDING: '/educational-onboarding',
    INSTALLMENTS: '/installments',
    MERCHANT: '/merchant',
  };

  static Sources = {
    HOME: 'home',
    WALLET: 'wallet',
    NOTIFICATIONS: 'notifications',
  };

  static EndFlowActions = {
    [NavigationUtils.Sources.HOME]: () => CloseWebviewEvent.closedByUser(),
    [NavigationUtils.Sources.WALLET]: () =>
      NavigationUtils.navigate(NavigationUtils.Routes.WALLET, true),
    [NavigationUtils.Sources.NOTIFICATIONS]: () =>
      CloseWebviewEvent.closedByUser(),
  };

  static navigate(url, replace = false, params = {}) {
    const newParams = new URLSearchParams();
    const organization = NavigationUtils.getOrganizationCode();
    const currentPath = window.location.pathname.replace('/', '');
    const source = NavigationUtils.getSource();

    if (organization) {
      newParams.set('organization', organization);
    }
    if (currentPath) {
      newParams.set('previousScreen', currentPath);
    }
    if (source) {
      newParams.set('source', source);
    }

    Object.keys(params).forEach(key => {
      if (![null, undefined].includes(params[key])) {
        newParams.set(key, params[key]);
      }
    });

    route(`${url}?${newParams.toString()}`, replace);
  }

  static getOrganizationCode() {
    const currentParams = new URLSearchParams(window.location.search);
    return currentParams.get('organization') || null;
  }

  static getSource() {
    const currentParams = new URLSearchParams(window.location.search);
    return currentParams.get('source') || null;
  }

  static getQueryParam(name) {
    const currentParams = new URLSearchParams(window.location.search);
    return currentParams.get(name) || null;
  }

  static back() {
    const currentParams = new URLSearchParams(window.location.search);
    const hasPrevious = !!currentParams.get('previousScreen');
    if (hasPrevious) {
      return history.back();
    }

    CloseWebviewEvent.closedByUser();
  }

  static endFlow() {
    const currentParams = new URLSearchParams(window.location.search);
    const source = currentParams.get('source') || null;
    const action = NavigationUtils.EndFlowActions[source];

    if (!source || !action) {
      return CloseWebviewEvent.closedByUser();
    }
    action();
  }
}
